module.exports = __webpack_public_path__ + "img/epigraphdb-logo.ed38e02a.svg";